import React from 'react';
import { MEMORY_GAME_MATCH_BLOCK } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import {
  MemoryGameProvider,
  TermsItem,
  DescriptionItem
} from './MemoryGameStore';
import { MemoryGameRoot } from '~/training/sequence/templates/items/memory-game/components/MemoryGameRoot';

interface Props {
  termsItems: TermsItem[];
  descriptionItems: DescriptionItem[];
}

export type MemoryGameBlockDefinition = ItemDefinition<
  typeof MEMORY_GAME_MATCH_BLOCK,
  Props
>;

export class MemoryGameBlock extends Item<
  typeof MEMORY_GAME_MATCH_BLOCK,
  Props
> {
  protected render({ termsItems, descriptionItems, id }: RenderProps<Props>) {
    return (
      <MemoryGameProvider
        termsItems={termsItems}
        descriptionItems={descriptionItems}
      >
        <MemoryGameRoot id={id} />
      </MemoryGameProvider>
    );
  }
}

registry[MEMORY_GAME_MATCH_BLOCK] = MemoryGameBlock;
